// Тема оформления: 'light' | 'dark' | 'system' (по умолчанию — как на устройстве)
const KEY = 'theme';
const ACCENT_KEY = 'accent';
const META_COLORS = { light: '#ffffff', dark: '#1e1f22' };
let mql = null;

export function getThemePreference() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch (e) { /* localStorage недоступен */ }
  return 'system';
}

// Цветовые гаммы: 'green' — классическая (по умолчанию), остальные включаются атрибутом data-accent на <html>
export const ACCENTS = ['green', 'red', 'blue', 'purple', 'orange', 'teal', 'pink'];

export function getAccentPreference() {
  try {
    const v = localStorage.getItem(ACCENT_KEY);
    return ACCENTS.includes(v) ? v : 'green';
  } catch (e) { return 'green'; }
}

export function setAccentPreference(accent) {
  const value = ACCENTS.includes(accent) ? accent : 'green';
  try { localStorage.setItem(ACCENT_KEY, value); } catch (e) { /* ignore */ }
  paintAccent(value);
}

function paintAccent(accent) {
  if (accent && accent !== 'green' && ACCENTS.includes(accent)) document.documentElement.setAttribute('data-accent', accent);
  else document.documentElement.removeAttribute('data-accent');
}

function resolve(pref) {
  if (pref === 'light' || pref === 'dark') return pref;
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch (e) { return 'light'; }
}

function paint(pref) {
  const theme = resolve(pref);
  document.documentElement.setAttribute('data-theme', theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', META_COLORS[theme]);
}

export function setThemePreference(pref) {
  try { localStorage.setItem(KEY, pref); } catch (e) { /* ignore */ }
  paint(pref);
}

export function initTheme() {
  paint(getThemePreference());
  paintAccent(getAccentPreference());
  try {
    if (!mql) {
      mql = window.matchMedia('(prefers-color-scheme: dark)');
      const onChange = () => { if (getThemePreference() === 'system') paint('system'); };
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else if (mql.addListener) mql.addListener(onChange);
    }
  } catch (e) { /* ignore */ }
}
